<template>
  <div>
   
    <apexchart
      type="heatmap"
      height="400"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
/*import barChart from './Bar.vue';*/
//import apifactory from "../../api";
export default {
  props: {
    variables: null,
    data: null,
  },
  components: {
    apexchart: VueApexCharts,
    /* barChart,*/
  },
  data() {
    return {
      varchartdata: [],
      chartFilter: null,
      chartfilterdependentvar: null,
      chartdataFortestafterfilter: [],
      chartdataFortest: [],
      //prevstepQueryStringParm: [],
      //prevstepQueryStringParmUrl: '',
      series: [],

      chartOptions: {
        chart: {
          fontFamily: "Lato",
        },
        heatmap: {
          shadeIntensity: 0.5,
          radius: 0,
          useFillColorAsStroke: true,
          colorScale: {
            ranges: [
              {
                from: -1,
                to: -0.5,
                name: "low",
                color: "#00A100",
              },
              {
                from: -0.51,
                to: 0,
                name: "medium",
                color: "#128FD9",
              },
              {
                from: 0.1,
                to: 0.5,
                name: "high",
                color: "#FFB200",
              },
              {
                from: 0.51,
                to: 1,
                name: "extreme",
                color: "#FF0000",
              },
            ],
          },
          distributed: true,
        },
        colors: ["#008FFB"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 1,
        },
        legend: {
          show: true,
          position: "bottom",
        },
        xaxis: {
          labels: {
            style: {
              colors: "#9AA1A9",
              fontWeight: "bold",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: ["#9AA1A9"],
              fontWeight: "bold",
            },
          },
        },
      },

      chartsData: [],
      chartsDataNew: [],
    };
  },
  methods: {
    bindGraph(chartdata, IndependentvariablesSelected,dependentvariables) {
      //alert(JSON.stringify(chartdata));
      this.varchartdata = [];
      this.varchartdata = chartdata;
      this.chartFilter = IndependentvariablesSelected;
      this.chartdataFortest = chartdata;
      this.chartfilterdependentvar=dependentvariables;
      

      let tempoutdata = [];
      for (let el in this.chartdataFortest) {
        //alert(this.chartdataFortest[el].variable);
        for (let k in this.chartFilter) {
          if (this.chartdataFortest[el].variable === this.chartFilter[k]) {
            tempoutdata.push(this.chartdataFortest[el]);
          }
        }
        for(let i in this.chartfilterdependentvar)
        {
           if (this.chartdataFortest[el].variable === this.chartfilterdependentvar[i]) {
            tempoutdata.push(this.chartdataFortest[el]);
          }
        }
      }
      // let newjson=JSON.parse(tempoutdata);
      this.chartdataFortestafterfilter = tempoutdata;

      let resultdata = [];

      for (let k1 in this.chartdataFortestafterfilter) {
        var obj = new Object();
        obj.name = this.chartdataFortestafterfilter[k1].variable;
        //obj.name1 = this.chartsData[k1];
        let innerarray = [];
        //let removekey=['region','variable'];
        for (var i in this.chartdataFortestafterfilter[k1]) {
          // alert(removekey.findIndex(i));
          if (i != "region") {
            if (i != "variable") {
              for(let vv in this.chartFilter)
              {
                if(this.chartFilter[vv] == i)
                {
                  var objinner = new Object();
                  objinner.x = i;                 
                  objinner.y = this.chartdataFortestafterfilter[k1][i];
                  innerarray.push(objinner);
                }
                
              }
              for(let vv1 in this.chartfilterdependentvar)
              {
                if(this.chartfilterdependentvar[vv1] == i)
                {
                  var objinner1 = new Object();
                  objinner1.x = i;                 
                  objinner1.y = this.chartdataFortestafterfilter[k1][i];
                  if (objinner1.x !== 'Sales_Value') {
                    innerarray.push(objinner1);
                  }
                }
                
              }
            }
          }
        }

        obj.data = innerarray;
        resultdata.push(obj);
      }
      this.series = resultdata.filter(item => item.name !== 'Sales_Value')
    },
  },
};
</script>
